<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/bdql.png')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>
      <!-- 标题介绍 -->
      <h3 style="text-align: initial; color: #000">
        <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
      </h3>

      <!-- 月份 -->
      <div class="cardClass" style="flex-wrap: wrap">
        <div
          v-for="(item, i) in monthList"
          :key="i"
          class="monthClass"
          @click="OpenDetail(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showZtjz"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <div class="vanDialogClass">
        <!-- 最顶部标题 -->
        <h3 style="text-align: initial; color: #000">
          <span style="color: #69a6f7">▋</span> {{ dataTitle }}
        </h3>
        <!-- 表格 -->
        <div class="tableBoxClass">
          <div class="tableTitleClass">{{ tableConfigObj.title }}</div>
          <div class="tableParent">
            <table class="tableCls">
              <thead>
                <tr>
                  <th
                    v-for="(item, index) in date
                      ? tableConfigObj.columns1
                      : tableConfigObj.columns"
                    :key="index"
                  >
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="showZtjz && tableDataList.length !== 0">
                <template v-for="(item, index) in tableDataList">
                  <tr
                    v-for="(item2, index2) in item.list"
                    :key="index2 + 's2' + index"
                  >
                    <template v-if="item.type == 'column'">
                      <template
                        v-for="(column, index3) in date
                          ? tableConfigObj.columns1
                          : tableConfigObj.columns"
                      >
                        <td
                          :key="index3 + 's3' + index2"
                          v-if="index2 == 0 && index3 == 0"
                          :rowspan="item.list.length"
                        >
                          {{ item[column.key] }}
                        </td>

                        <td
                          :key="index3 + 's1' + index2"
                          v-else-if="index3 != 0"
                          :style="{
                            color: item2[column.key + 'Color']
                              ? item2[column.key + 'Color']
                              : '#000',
                          }"
                        >
                          {{ item2[column.key] }}
                        </td>
                      </template>
                    </template>
                    <template v-else-if="item.type == 'line'">
                      <td colspan="3">
                        {{ item.street }}
                      </td>
                      <td>
                        {{ item2.cqhs }}
                      </td>
                      <td>
                        {{ item2.bqwc }}
                      </td>
                      <td>
                        {{ item2.ljwc }}
                      </td>
                      <td>
                        {{ item2.syhs }}
                      </td>
                      <td></td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>

            <div
              style="
                height: 20px;
                width: 100%;
                color: darkgoldenrod;
                text-align: center;
                margin-top: 20px;
              "
              v-if="tableDataList.length == 0"
            >
              暂无数据
            </div>
            <div class="remarkCls flex-column-center" v-if="!date">
              <span class="remarkTextCls">{{ remarkText }}</span>
              <div>统计时间：{{ remarkText2 }}</div>
            </div>
          </div>
        </div>
        <div class="closeBtnClass" @click="CloseDetail">关闭</div>
      </div>
    </van-dialog>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
import Table from './custom/Table.vue'
import { getDict } from '../api/zdqd.js'
import { ApiGetBDQL } from '../api/zsyz'
import { deepClone } from '../utils/deepClone'
export default {
  name: 'bdql',
  components: { Table },
  data() {
    return {
      // 后台获取的年份列表
      selectYearsColumns: [],
      // 获取今年
      // selectYear: new Date().getFullYear(),
      selectYear: process.env.VUE_SELECT_YEAR,
      // 当前月份
      currentMonth: new Date().getMonth() + 1,
      date: true,
      // 是否显示背景暂无数据
      showZtjz: false,
      // 顶部标题数据
      dataTitle: '北仑区征迁重点项目"拔钉清零"完成情况',
      //   备注
      remarkText: '备注：绿色为完成项目，红色为滞后项目。',
      remarkText2: '',
      // 月份
      monthList: [
        { label: '1月', value: 1 },
        { label: '2月', value: 2 },
        { label: '3月', value: 3 },
        { label: '4月', value: 4 },
        { label: '5月', value: 5 },
        { label: '6月', value: 6 },
        { label: '7月', value: 7 },
        { label: '8月', value: 8 },
        { label: '9月', value: 9 },
        { label: '10月', value: 10 },
        { label: '11月', value: 11 },
        { label: '12月', value: 12 },
      ],
      // 传给表格的数据
      tableConfigObj: {
        columns: [
          { text: '所属街道', key: 'street' },
          { text: '序号', key: 'sort' },
          { text: '项目名称', key: 'name' },
          { text: '拆迁户数', key: 'cqhs' },
          { text: '本期完成', key: 'bqwc' },
          { text: '累计完成', key: 'ljwc' },
          { text: '剩余户数', key: 'syhs' },
          { text: '完成时限', key: 'wcsx' },
        ],
        columns1: [
          { text: '所属街道', key: 'street' },
          // { text: '序号', key: 'sort' },
          { text: '目标户数', key: 'cqhs' },
          { text: '完成户数', key: 'ljwc' },
          { text: '剩余户数', key: 'syhs' },
        ],
        title: '',
      },
      // 传给表格的数据
      tableDataList: [],
    }
  },
  created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then((res) => {
      res.data.content.forEach((x) => {
        this.selectYearsColumns.push(x.label)
      })
    })
  },
  methods: {
    async init(selectYear, currentMonth) {
      const res = await ApiGetBDQL({ year: selectYear, month: currentMonth })
      let tableDataList = deepClone(res.data.result)
      this.tableDataList = tableDataList.filter((x) => x.street != '小计')
      this.remarkText2 = res.data.statisticsTime
    },
    selectChange(e) {
      this.selectYear = e.target.value
    },
    async OpenDetail(value) {
      this.currentMonth = value
      this.init(this.selectYear, this.currentMonth)
      this.tableConfigObj.title = `${this.selectYear}年${this.currentMonth}月`
      let currentMonth = ''
      if (value < 10) {
        currentMonth = '0' + value
      } else {
        currentMonth = value
      }
      let date = `${this.selectYear}-${currentMonth}`
      if (date >= '2025-05') {
        this.date = true
      } else {
        this.date = false
      }
      this.showZtjz = true
    },
    CloseDetail() {
      this.showZtjz = false
    },
  },
}
</script>

<style scoped>
.monthClass {
  background-color: #69a6f7;
  border-radius: 10px;
  width: 70px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  margin: 5px;
}

.vanDialogClass {
  text-align: initial;
  padding: 25px 20px;
  height: 100%;
}

.closeBtnClass {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 80%;
  height: 45px;
  line-height: 45px;
  background-color: #69a6f7;
  text-align: center;
  border-radius: 30px;
  color: #fff;
  letter-spacing: 16px;
}

.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
.tableBoxClass {
  margin-top: 20px;
  color: #000;
  height: 100%;
}
.tableTitleClass {
  width: 100%;
  background-color: #69a6f7;
  font-weight: 700;
  text-align: center;
  color: #000;
  border-radius: 10px 10px 0 0;
  padding: 5px 0;
}

.tableCls {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  /* border: 1px solid #e3edf6; */
  border-collapse: collapse;
  text-align: center;
}
.tableParent {
  overflow: auto;
  height: calc(100% - 200px);
}
table thead {
  position: sticky;
  top: 0;
  background-color: #fff;
}
table thead th,
table tbody td {
  border: 1px solid #e3edf6;
  padding: 5px;
}

table tbody td {
  font-weight: 400;
  color: #000;
}
.remarkCls {
  color: #000;
  font-size: 12px;
  margin-top: 20px;
}
.remarkTextCls::before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #69a6f7;
  margin-right: 10px;
}
.van-dialog >>> .van-dialog__content {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bdql.vue